module.exports = __webpack_public_path__ + "static/media/elevated3-desktop.0cbcaa6d.jpg";